const generateSystemName = (str, ignoreTrailing = true) => {
    if (!str)
        return null;

    const result = str.toLowerCase()
        .replace(/[^a-z0-9]/g, "-")         // replaces anything not a-z/0-9 with -
        .replace(/\-+/g, "-");              // replaces any multiple -'s with single -

    // removes leading (and optionally trailing) -'s
    return ignoreTrailing
        ? result.replace(/(^\-+)/g, "")
        : result.replace(/(^\-+)|(\-+$)/g, "");
}

const withErrorHandling = function (func) {
    return async function () {
        const vm = this;
        const args = arguments;

        try {
            await func.apply(vm, args);
        } catch (error) {
            vm.$store.commit("error", { message: "Unable to complete the operation.  Sharedo may be unavailable" })
        }
    }
}

export {
    generateSystemName,
    withErrorHandling
}

export default {
    generateSystemName
}